export const NOTEBOOK_PAGINATION_LIMIT = 20;

export const FORMAT_DATE = 'MMMM dd, yyyy';

export const UNASSIGNED_MEMBER_ID = '000000000000000000000000';

export const DUE_DATE_FORMAT = "yyyy-MM-dd'T'00:00:00.000'Z'";
